export function initActiveHeartBeat(onActiveHeartBeat: (event:string) => void) {
  let lastCallTime =  Date.now(); //第一次必上报
  onActiveHeartBeat('init');
  function doActive(event:string) {
    const thisCallTime = Date.now();
    // 超过一分钟才上报
    if (thisCallTime - 60 * 1000 > lastCallTime) {
      onActiveHeartBeat && onActiveHeartBeat(event);
      lastCallTime = thisCallTime;
    }
  }

  const events = ['touchstart', 'keydown', 'focus', 'scroll', 'mousemove', 'mousedown'];

  try {
    let passiveSupported = false;
    const options = Object.defineProperty({}, 'passive', {
      get: function () {
        passiveSupported = true;
      }
    });

    window.addEventListener('test', () => {}, options);

    events.forEach(event => {
        document.addEventListener(event, function(){
          doActive(event);
        }, passiveSupported ? { passive: true, capture: true } : true);
      });
  } catch (err) {
    console.error(err);
  }

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') {
      doActive('visible');
    }
  });
}
